import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_check",
  "use": "icon_check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon_check\"><path stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\" d=\"M12 4.91602 6.5 10.416 4 7.91602\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol